import { render, staticRenderFns } from "./DriverVehicleStep.vue?vue&type=template&id=ffc4b662"
import script from "./DriverVehicleStep.vue?vue&type=script&lang=js"
export * from "./DriverVehicleStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports